import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation GenerateFullBlogPost(
    $projectId: ID!
    $maxWords: Int
    $debugAcPrompt: String
    $customerPersonaId: ID
    $tovInput: TovInput
    $blogLength: Int
    $generateHeaders: Boolean
  ) {
    generateFullBlogPost(
      projectId: $projectId
      maxWords: $maxWords
      debugAcPrompt: $debugAcPrompt
      customerPersonaId: $customerPersonaId
      tovInput: $tovInput
      blogLength: $blogLength
      generateHeaders: $generateHeaders
    ) {
      id
      blogPostBuilderDraftId
    }
  }
`;

interface Params {
  projectId: ID;
  maxWords?: number;
  debugAcPrompt?: string;
  customerPersona?: any;
  tovInput?: any;
  blogLength?: number;
  generateHeaders?: boolean;
}

interface Result {
  id: ID;
  blogPostBuilderDraftId: ID;
}

export const generateFullBlogPost = async ({
  projectId,
  maxWords,
  debugAcPrompt,
  customerPersona,
  tovInput,
  blogLength,
  generateHeaders,
}: Params) => {
  const variables = {
    projectId,
    maxWords,
    debugAcPrompt,
    customerPersonaId: customerPersona?.id,
    tovInput,
    blogLength,
    generateHeaders,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });

  return getSingleProp<Result>(result.data);
};
